import logo from '../assets/taco_bgred.png';

const appSettings = {
  title: 'Taco',
  logo: logo,
};

export default appSettings;